module.exports = __webpack_public_path__ + "img/nav.011ebae3.jpg";